import React, { useState } from 'react';
import {
  Button, Input, InputNumber,
} from 'antd';
import { useNavigate } from 'react-router-dom';
import { IconComment } from '../../../Common/Icon';

import styles from './index.module.scss';

export default function ShareYourTwoCents(): React.ReactElement {
  const navigate = useNavigate();

  return (
    <div className={styles.wrapper}>
      <div className={styles.content}>
        <h3>&apos;Share Your Two Cents&apos; and describe your tipping experience </h3>
        <Button
          style={{ height: 50 }}
          icon={<IconComment />}
          type="primary"
          size="large"
          onClick={() => navigate('/share-your-two-cents')}
        >
          Leave Comment
        </Button>
      </div>
    </div>
  );
}
